import React from 'react';
import AssignmentStatusBadge from './AssignmentStatusBadge';
import makeStyles from '@mui/styles/makeStyles';
import { ASSIGNMENT_STATUSES, AssignmentWithCover } from '../types';

type AssignmentCoverProps = {
  assignment: AssignmentWithCover;
  showLetterBookBadge: boolean;
  status: ASSIGNMENT_STATUSES;
  style?: Record<any, any>;
};

const AssignmentCover: React.FC<AssignmentCoverProps> = ({
  assignment,
  showLetterBookBadge,
  style = {},
  status,
}) => {
  const classes = styles();

  return (
    <div className={classes.container}>
      <AssignmentStatusBadge
        assignment={assignment}
        showLetterBookBadge={showLetterBookBadge}
        status={status}
        style={{
          left: '50%',
          position: 'absolute',
          transform: 'translate(-50%, -50%)',
          zIndex: 1,
        }}
      />
      <div className={classes.frameContainer}>
        <iframe
          className={classes.frame}
          srcDoc={assignment?.cover?.html}
          title={assignment?.cover?.title}
          style={{ ...style, height: '100%', width: '100%' }}
        />
        <div className={classes.frameOverlay} />
      </div>
    </div>
  );
};

const styles = makeStyles(() => ({
  container: {
    display: 'flex',
    position: 'relative',
    width: '100%',
    height: '100%',
    minWidth: 0,
    minHeight: 0,
    overflow: 'visible',
  },
  frameContainer: {
    height: '100%',
    width: '100%',
    position: 'relative',
    overflow: 'hidden',
  },
  frame: {
    border: 'none',
    display: 'block',
  },
  frameOverlay: {
    height: '100%',
    left: 0,
    position: 'absolute',
    top: 0,
    width: '100%',
  },
}));

export default AssignmentCover;
